import { useLoggingMutation } from 'lib/apollo/apollo-hooks';
import { getCurrentClass } from 'approot/classes/classes.apollo';
import { getClassTeacher } from 'approot/classes/classes.utils';
import useUserData from 'approot/shared/user/user-data';
import { SET_RECENTLY_VIEWED_CONTENT } from './recently-viewed-content.graphql';
import type {
  SetRecentlyViewedContentMutation,
  SetRecentlyViewedContentMutationVariables,
} from './recently-viewed-content.graphql.generated';

export const useSetRecentlyViewedContent = () => {
  const { user } = useUserData();

  return useLoggingMutation<
    SetRecentlyViewedContentMutation,
    SetRecentlyViewedContentMutationVariables
  >(SET_RECENTLY_VIEWED_CONTENT, {
    update: cache => {
      const currentClass = getCurrentClass();
      if (!currentClass || !user?.id) return;
      const classTeacher = getClassTeacher(currentClass, user.id);
      if (!classTeacher) return;
      cache.modify({
        id: cache.identify({
          __typename: 'ClassTeacher',
          id: classTeacher.id,
        }),
        fields: {
          hasRecentlyViewedContent: () => true,
        },
      });
    },
  });
};
